export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/78489dd5fe22b2b724f99f5861a7cee7.svg";